import { combineReducers } from 'redux';
import businesses, { IBusinessesState } from './businessesReducer';
import checkIns, { ICheckInsState } from './checkInsReducer';
import inventory, { IInventoryState } from './inventoryReducer';
import router, { IRouterState } from './routerReducer';
import users, { IUsersState } from './usersReducer';

export interface IState {
  businesses: IBusinessesState;
  checkIns: ICheckInsState;
  inventory: IInventoryState;
  router: IRouterState;
  users: IUsersState;
}

const rootReducer = combineReducers({
  businesses,
  checkIns,
  inventory,
  router,
  users,
});

export default rootReducer;

export * from './businessesReducer';
export * from './checkInsReducer';
export * from './inventoryReducer';
export * from './routerReducer';
export * from './usersReducer';



// WEBPACK FOOTER //
// ./src/store/reducers/index.ts